import React from 'react'
import { useQuery } from '@apollo/client';
import { BLOG_POST_COMMENTS } from '../../utils/constants/queries';
import { ErrorComponent } from '../error';
import Comment from './Comment'
import { AddComment } from '..';

export default function Comments(props) {
    const postId = props.post
    const { loading, error, data } = useQuery(BLOG_POST_COMMENTS, {
        variables: {
            blogId: postId,
        }
    });

    const commentsWidget = loading ? <p>Loading...</p> :error ? <ErrorComponent message ={error.message}/>:
    data.comments.map((comment)=><Comment key={comment.id} comment = {comment}/>)
    return (
        <div className="comments-area">
            <h3 className="comments-title">{data?data.comments_aggregate.aggregate.count:0} Comments:</h3>
            <ol className="comment-list">
                {commentsWidget}
            </ol>
                <AddComment post ={postId}/>
              </div>

    )
}
